(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-subscription-line"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cardSubLineBound) return;
    window.__cardSubLineBound = true;

    // Delegação em capture: define a variante (única/Mensal) conforme o botão
    // clicado, antes do <product-form> do tema montar o FormData no submit.
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var sub = e.target.closest('[data-sub-add]');
        var once = sub ? null : e.target.closest('[data-once-add]');
        var trigger = sub || once;
        if (!trigger) return;
        var form = trigger.closest('form');
        if (!form) return;
        var input = form.querySelector('[data-variant-input]');
        if (!input) return;
        input.value = sub ? input.dataset.variantSub : input.dataset.variantOnce;
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
